import { useEffect } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import { useSystemPlans } from '../../hooks/system/useSystemPlans';
import SystemPlansTable from '../../components/system/SystemPlansTable';

/**
 * 📦 Página de Plan del Sistema
 *
 * Permite visualizar el plan activo del sistema
 * y las funcionalidades habilitadas según la licencia.
 */
const SystemPlanPage = () => {
  const { plans, fetchPlans, changePlan } = useSystemPlans();

  useEffect(() => {
    fetchPlans();
  }, []);

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SystemPlansTable plans={plans} onChangePlan={changePlan} />
    </DefaultLayout>
  );
};

export default SystemPlanPage;
